import * as actionTypes from "../actionTypes";
import {toastError, toastSuccess} from "../../shared/components/toast/Toast";
import {store} from "../store";
import * as actions from '../index';
import SimService from "../../api/simService";
import ServiceRequestsService from "../../api/serviceRequestsService";
import {TagsService} from "../../api/tagsService";
import {SomService} from "../../api/somService";
import {initialFilterState} from "../../components/mobile/sub-menu-items/device-v2/DeviceHelper";

export const getCategoriesInSegnalazione = (customerId, assistenzaId, screenCode, returnReferente, prodottoId) => {
    const changeInSelf = store.getState().authReducer.selectedCompany.changeInSelf;

    return dispatch => {
        ServiceRequestsService.fetchCategories(customerId, assistenzaId, screenCode, returnReferente, changeInSelf, prodottoId)
            .then(res => {
                if (returnReferente) {
                    dispatch({
                        type: actionTypes.GET_CATEGORIES_AND_REFERENTE_IN_SEGNALAZIONE,
                        categoria: res.data.selectValues,
                        referentes: res.data.referentes,
                        addReferente: [{
                            value: "divider",
                            text: "divider"
                        }, {
                            value: "Aggiungi referente per questa segnalazione",
                            text: "Aggiungi referente per questa segnalazione",
                            bold: true
                        }]
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_CATEGORIES_IN_SEGNALAZIONE,
                        categoria: res.data.selectValues,
                        referentes: [],
                    });
                }
            })
            .catch(e => {
                console.log(e);
            })
    }
}

export const getAreasInSegnalazione = (customerId, assistenzaId, screenCode, categoriaId, prodottoId) => {
    const changeInSelf = store.getState().authReducer.selectedCompany.changeInSelf;

    return dispatch => {
        ServiceRequestsService.fetchAreas(customerId, assistenzaId, screenCode, categoriaId, changeInSelf, prodottoId)
            .then(res => {
                dispatch({
                    type: actionTypes.GET_AREAS_IN_SEGNALAZIONE,
                    areas: res.data.selectValues
                });
            })
            .catch(e => {
                console.log(e);
            })
    }
}

export const getDettaglioInSegnalazione = (customerId, assistenzaId, screenCode, categoriaId, areaId, prodottoId) => {
    const changeInSelf = store.getState().authReducer.selectedCompany.changeInSelf;

    return dispatch => {
        ServiceRequestsService.fetchDettaglio(customerId, assistenzaId, screenCode, categoriaId, areaId, changeInSelf, prodottoId)
            .then(res => {
                dispatch({
                    type: actionTypes.GET_DETTAGLIO_IN_SEGNALAZIONE,
                    dettaglio: res.data.selectValues
                })
            })
            .catch(e => {
                console.log(e);
            })
    }
}

export const submitReportInSegnalazione = (
    customerId, assistenzaId, screenCode, userId, categoriaId, areaId, dettaglioId,
    message, referenteId, data, note, addOptions = [], removeOptions = [], handleNextStep
) => {
    const changeInSelf = store.getState().authReducer.selectedCompany.changeInSelf

    const reportProblemDto = {
        customerId: customerId,
        assistenzaId: assistenzaId,
        screenCode: screenCode,
        userId: userId,
        categoriaId: categoriaId,
        areaId: areaId,
        dettaglioId: dettaglioId,
        message: message,
        addPlanOptions: addOptions,
        removePlanOptions: removeOptions,
        referenteId: referenteId,
        simList: data,
        note: note,
        changeInSelf: changeInSelf
    }

    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "loading", value: true})
        dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "error", value: false})
        ServiceRequestsService.reportProblem(reportProblemDto)
            .then(res => {
                dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "success", value: true})
                toastSuccess("Operazione completata")
                if (handleNextStep) handleNextStep()
            })
            .catch(e => {
                console.log(e.response.data.message);
                dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "error", value: true})
                toastError("Non è stato possibile inoltrare la richiesta.")
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "success", value: false})
                dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "loading", value: false})
            })
    }
}

export const resetReportResponse = () => {
    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "success", value: false})
        dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "loading", value: false})
        dispatch({type: actionTypes.SET_LOADING_SUCCESS_ERROR_REPORT_PROBLEM, typeOf: "error", value: false})
    }
}

export const getOperators = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return dispatch => {
        ServiceRequestsService.fetchOperators(integrationId)
            .then(res => {
                dispatch({
                    type: actionTypes.GET_OPERATORS,
                    operators: res.data
                })
            })
            .catch((e) => {
                console.log(e)
            })
    }
}

export const clearOperators = () => {
    return ({
        type: actionTypes.CLEAR_OPERATORS,
        operators: []
    })
}

export const clearSegnalazione = () => {
    return ({
        type: actionTypes.CLEAR_SEGNALAZIONE,
        segnalazione: {
            categoria: [],
            areas: [],
            dettaglio: [],
            referentes: []
        }
    })
}

export const rechargeSim = (iccId, msisdn, amount, userId, companyId) => {
    const rechargeSimDto = {
        iccId: iccId,
        msisdn: msisdn,
        amount: amount,
        userId: userId,
        companyId: companyId
    };

    return dispatch => {
        ServiceRequestsService.rechargeSim(rechargeSimDto).then(res => {
            toastSuccess(res.data.resultDescription);
            dispatch({type: actionTypes.UPDATE_CREDIT, amount: getCreditString(amount)})
        }).catch(e => {
            toastError(e.response.data.resultDescription);
        })
    }
}

export const changeThreshold = (iccId, msisdn, userId, companyId, newValore, newSoglia, offeringId, tipologiaAbbonamento, tipologiaWallet) => {
    const changeThresholdDto = {
        iccId: iccId,
        msisdn: msisdn,
        userId: userId,
        companyId: companyId,
        newValore: newValore,
        newSoglia: newSoglia,
        offeringId: offeringId,
        tipologiaAbbonamento: tipologiaAbbonamento,
        tipologiaWallet: tipologiaWallet
    };

    return dispatch => {
        ServiceRequestsService.changeThreshold(changeThresholdDto).then(res => {
            //TODO: response
            toastSuccess(res.data.soapResultHeader.resultDescription);
            dispatch({type: actionTypes.UPDATE_THRESHOLD, creditoItem: res.data.creditoItem})
        }).catch(e => {
            //TODO: error
            toastError(e.response.data.soapResultHeader.resultDescription);
        })
    }
}

export const sendSomRequest = (selectedOptions, simList, userId, customerId, somActionTypeEnum) => {
    const sendSomRequestDto = {
        selectedOptions: selectedOptions,
        simList: simList,
        userId: userId,
        customerId: customerId,
        somActionTypeEnum: somActionTypeEnum
    }
    ServiceRequestsService.sendSomRequest(sendSomRequestDto).then(res => {
        console.log("Service Request sent: " + res.status);
    }).catch(e => {
        console.log(e);
    })
}

export const getAddressForCustomerId = (customerId) => {
    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_GET_ADDRESS_FOR_CUSTOMER, loading: true});
        ServiceRequestsService.fetchAddressForCustomerId(customerId).then((res) => {
            dispatch({
                type: actionTypes.GET_ADDRESS_FOR_CUSTOMER,
                customerAddress: res.data.address
            })
        }).catch(e => {
            console.log(e);
        }).finally(() => {
            dispatch({type: actionTypes.SET_LOADING_GET_ADDRESS_FOR_CUSTOMER, loading: false});
        })
    }
}

export const clearCustomerAddress = () => {
    return ({
        type: actionTypes.CLEAR_CUSTOMER_ADDRESS,
        customerAddress: ""
    })
}

export const getRamGroupsForCustomer = (customerId, simIccIdMsisdnList) => {
    const checkSomCallPossibilityDto = {
        integrationId: customerId,
        iccIdList: simIccIdMsisdnList.map(sim => sim.iccId)
    }

    const getRamGroupsDto = {
        customerId: customerId,
        simList: simIccIdMsisdnList
    }

    return dispatch => {
        SomService.canMakeSomCall(checkSomCallPossibilityDto)
            .then(() => {
                dispatch({type: actionTypes.SET_CHANGE_RAM_PARAMS, name: "loading", payload: true});
                ServiceRequestsService.fetchRamGroups(getRamGroupsDto)
                    .then(res => {
                        dispatch({type: actionTypes.SET_CHANGE_RAM_PARAMS, name: "options", payload: res.data});
                    })
                    .catch(e => {
                        console.log(e);
                    })
                    .finally(() => {
                        dispatch({type: actionTypes.SET_CHANGE_RAM_PARAMS, name: "loading", payload: false});
                    })
            })
            .catch(e => {
                dispatch({type: actionTypes.SET_CHANGE_RAM_PARAMS, name: "options", payload: []});
                console.error(e.response.data.message)
                toastError(e.response.data.message)
            })
    }
}

export const createNewTag = (tagName, objectCategory, createTagType, tagColor = "#4fc0e8") => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const body = {
        clientName: "PME",
        objectCategoryName: objectCategory,
        integrationId: integrationId,
        tagName: tagName,
        tagColor: tagColor
    }

    return dispatch => {
        TagsService.insertTag(body).then((res) => {
            if (res.data.storedProcedureResponseDto.result_code === 0) {
                if (createTagType === "SIM") {
                    toastSuccess("Ricordati di selezionare il tag per completare la creazione e l'associazione alla SIM")
                    dispatch({
                        type: actionTypes.CREATE_TAG_SIM,
                        tag: {
                            checked: false,
                            label: tagName,
                            inEverySim: false,
                            id: res.data.tagId,
                            color: tagColor
                        }
                    })
                } else if (createTagType === "DEVICE") {
                    toastSuccess("Ricordati di selezionare il tag per completare la creazione e l'associazione alla Device")
                    dispatch({
                        type: actionTypes.CREATE_TAG_DEVICE,
                        tag: {checked: false, label: tagName, inEverySim: true, id: res.data.tagId, color: tagColor}
                    })
                }
                dispatch({
                    type: actionTypes.CREATE_TAG_SELECTED_ITEMS,
                    tag: {checked: false, label: tagName, inEverySim: true, id: res.data.tagId, color: tagColor}
                })
            } else if (res.data.storedProcedureResponseDto.result_code === -3001) {
                toastError("Il tag con quel nome esiste già.")
            } else {
                toastError("Operazione fallita.")
            }
        }).catch((e) => {
            console.log(`Create new tag: ${e.response.data.message}`)
            toastError("Operazione fallita.")
        })
    }
}

export const editTag = (tagId, tagName, tagColor, itemType) => {
    const body = {
        tagId: tagId,
        tagName: tagName,
        tagColor: tagColor
    }
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return dispatch => {
        TagsService.editTag(integrationId, body).then((res) => {
            if (res.data.result_code === 0) {
                if (itemType === "SIM") {
                    dispatch({
                        type: actionTypes.EDIT_TAG_SIM,
                        tagId: tagId,
                        tagName: tagName,
                        tagColor: tagColor
                    })
                }
                if (itemType === "DEVICE") {
                    dispatch({
                        type: actionTypes.EDIT_TAG_DEVICE,
                        tagId: tagId,
                        tagName: tagName,
                        tagColor: tagColor
                    })
                }
                toastSuccess("Tag aggiornato con successo")
            } else {
                toastError("Impossibile aggiornare il tag")
            }
        }).catch(e => {
            console.log(`Edit tag: ${e.response.data.message}`)
            toastError("Operazione fallita")
        })
    }
}

export const deleteTag = (tagLabel, objectCategory, createTagType) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const body = {
        clientName: "PME",
        objectCategoryName: objectCategory,
        integrationId: integrationId,
        objectExternalId: "PME",
        tagName: tagLabel
    }
    return dispatch => {
        TagsService.deleteTag(body).then((res) => {
            if (res.data.result_code === 0) {
                toastSuccess(`"${tagLabel}" rimosso con successo`)
                if (createTagType === "SIM") {
                    dispatch({
                        type: actionTypes.DELETE_TAG_SIM,
                        tagLabel: tagLabel
                    })
                } else if (createTagType === "DEVICE") {
                    dispatch({
                        type: actionTypes.DELETE_TAG_DEVICE,
                        tagLabel: tagLabel
                    })
                }
            } else if (res.data.result_code === -3001) {
                toastError("Il tag con quel nome esiste già.")
            } else {
                toastError("Operazione fallita.")
            }
        }).catch((e) => {
            console.log(`Delete tag: ${e.response.data.message}`)
            toastError("Operazione fallita.")
        })
    }
}

export const getTagsForSelectedItems = (ids, objectCategory) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const body = {
        clientName: "PME",
        objectCategoryName: objectCategory,
        integrationId: integrationId,
        objectExternalIds: ids
    }

    return dispatch => {
        dispatch({
            type: actionTypes.LOADING_TAGS_SELECTED_ITEMS,
            loading: true
        })
        TagsService.fetchTagsForSelectedItems(body)
            .then((res) => {
                dispatch({
                    type: actionTypes.SET_TAGS_FOR_SELECTED_ITEMS,
                    tags: res.data.tags,
                    firstRenderTasks: res.data.firstRenderTasks
                })
            })
            .catch((e) => {
                console.log(`Get tags for selected items: ${e.message}`)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.LOADING_TAGS_SELECTED_ITEMS,
                    loading: false
                })
            })
    }
}

export const updateMultipleTagAssociations = (updatedTags, clientName, objectCategoryName, objectExternalIds, areSims, typeDevice, fetchAfterConferma) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const body = {
        updatedTagList: updatedTags,
        clientName: clientName,
        objectCategoryName: objectCategoryName,
        integrationId: integrationId,
        objectExternalIdList: objectExternalIds
    }

    return dispatch => {
        dispatch({
            type: actionTypes.SET_LOADING_GESTISCI_TAG,
            typeOf: areSims ? "loadingSim" : "loadingDevice",
            value: true
        })
        TagsService.updateMultipleAssociations(body).then(() => {
            if (areSims) {
                dispatch(actions.fetchAllSimData())
                dispatch(actions.fetchSimTagsAutocomplete(""))
            } if(typeDevice === "noleggio"){
                dispatch(actions.getNoleggioTable(0, 5,"null,DESC", integrationId, initialFilterState))
                return;
            } if(typeDevice === "vendita"){
                dispatch(actions.getVenditaTable(0, 5, "null,DESC", integrationId, initialFilterState))
                return;
            } if(typeDevice === "restituzioniDetails"){
                fetchAfterConferma();
                return;
            } else {
                dispatch(actions.getDevices(0, 5));
                dispatch(actions.fetchDeviceTagsAutocomplete(""))
            }
            toastSuccess("Associazioni aggiornate con successo");
        }).catch((e) => {
            console.error(`Updating multiple associations: ${e.message}`);
        }).finally(() => {
            dispatch({
                type: actionTypes.SET_LOADING_GESTISCI_TAG,
                typeOf: areSims ? "loadingSim" : "loadingDevice",
                value: false
            })
        })
    }
}


const getCreditString = (amount) => {
    let currentCredit = store.getState().simReducer.ocsDetails.creditoOrCanoneValue;
    let [creditValue, euroSign] = currentCredit.split(" ");
    creditValue = creditValue.replace(",", ".");
    let creditFloat = parseFloat(parseFloat(creditValue).toFixed(2));
    let addAmountFloat = parseFloat(parseFloat(amount).toFixed(2));
    const sum = (creditFloat + addAmountFloat).toFixed(2).replace(".", ",");
    return `${sum} ${euroSign}`;
}

export const addNewReferente = (name, surname, email, telefono) => {
    const tmpReferente = {
        name: name,
        surname: surname,
        text: name + ' ' + surname,
        telephone: telefono,
        email: email,
        value: email + '%_%' + name + ' ' + surname,
        added: true
    }
    return dispatch => {
        dispatch({
            type: actionTypes.ADD_NEW_REFERENTE,
            newReferente: tmpReferente
        })
    }
}

export const fetchSimSostituveSuggestions = (destinazioneRadioButton, iccId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_SUSPENSION_SIMS, payload: true})
        SimService.fetchSostitutiveSimSuggestions(integrationId, destinazioneRadioButton, iccId)
            .then((res) => {
                dispatch({
                    type: actionTypes.SET_SIM_SOSTITUVE,
                    data: res.data
                })
            })
            .catch((e) => {
                console.error(e)
                toastError("Operazione fallita. Per favore riprova più tardi")
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_SUSPENSION_SIMS, payload: false})
            })
    }
}
